export const baseDevUrl = "https://dev.marble.co";
export const previewUrlSuffix = "gtsb.io";

export const CLOUDFRONT_CITY_HEADER = "cloudfront-viewer-city";
export const CLOUDFRONT_STATE_HEADER = "cloudfront-viewer-country-region-name";
export const CLOUDFRONT_COUNTRY_CODE_HEADER = "cloudfront-viewer-country";
export const CLOUDFRONT_COUNTRY_NAME_HEADER = "cloudfront-viewer-country-name";

export const EMPTY_GEOLOCATION = { city: "" };
